export enum QuizCountry
{
    USA,
    Japan,
    Egypt,
    Australia,
    Canada,
    France,
    UK
}

export function getCountryNameByQuizCountry(country: QuizCountry)
{
    return "country-" + QuizCountry[country].toLowerCase();
}